export default "__VITE_ASSET__CVVoLKsZ__"